export default __webpack_public_path__ + "static/media/empty.592ed714.svg";